import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';

export const RecentFormsContainer = styled.ul`
    display: block;
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const RecentFormsHeader = styled.h2`
    ${fonts.h500};
    padding-bottom: ${token('space.200', '16px')};
`;

export const RecentFormItem = styled.li`
    display: block;
    word-wrap: break-word;
    position: relative;
    padding-bottom: ${token('space.200', '16px')};
`;
